import { useState, useEffect } from 'react'
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '../lib/firebase'

let cachedProjects = null
let fetchPromise = null

function normalizeProject(doc) {
  const data = doc.data()
  const tags = (data.tags || [])
    .map((tag) => {
      if (typeof tag === 'string') return tag
      if (typeof tag === 'object' && tag.name) return tag.name
      return String(tag)
    })
    .filter((tag) => tag && tag.trim() !== '')

  return {
    id: doc.id,
    name: data.title || data.name || 'Untitled Project',
    image: data.imageUrl || data.image || '',
    imageUrl: data.imageUrl || data.image || '',
    alt: data.description || 'Project screenshot',
    description: data.description || '',
    tags,
    projectLink: data.projectLink || null,
    liveLink: data.liveLink || null,
    createdAt: data.createdAt || new Date(),
    title: data.title || data.name || 'Untitled Project',
  }
}

async function fetchProjects() {
  if (cachedProjects) return cachedProjects
  if (fetchPromise) return fetchPromise

  fetchPromise = (async () => {
    try {
      const projectsRef = collection(db, 'projects')
      const q = query(projectsRef, orderBy('createdAt', 'desc'))
      const snapshot = await getDocs(q)
      cachedProjects = snapshot.docs.map(normalizeProject).filter((p) => p.imageUrl)
      return cachedProjects
    } catch (err) {
      console.error('Error fetching projects:', err)
      cachedProjects = []
      return cachedProjects
    } finally {
      fetchPromise = null
    }
  })()

  return fetchPromise
}

export function useProjects() {
  const [projects, setProjects] = useState(cachedProjects || [])
  const [loading, setLoading] = useState(!cachedProjects)

  useEffect(() => {
    let cancelled = false

    fetchProjects().then((data) => {
      if (!cancelled) {
        setProjects(data)
        setLoading(false)
      }
    })

    return () => {
      cancelled = true
    }
  }, [])

  return { projects, loading, count: projects.length }
}
